module.exports = __webpack_public_path__ + "img/calendar-minus.4d1662f6.svg";